import React from 'react';

function LoadingSpinner({ message = '로딩 중...' }) {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '4rem',
      minHeight: '240px'
    }}>
      <div style={{
        width: '40px',
        height: '40px',
        border: '3px solid #e5e7eb',
        borderTop: '3px solid #4f6ef7',
        borderRadius: '50%',
        animation: 'spin 0.8s linear infinite'
      }} />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      <p style={{
        marginTop: '1.2rem',
        color: '#6b7280',
        fontSize: '0.9rem',
        fontWeight: 500
      }}>{message}</p>
    </div>
  );
}

export default LoadingSpinner;
